"use strict"

import React from "react"
import { Button } from "react-bootstrap"

import ObservationSelectorPopper from "./ObservationSelectorPopper"
import { isLTPM } from "../../../../components/shared_components_registration"

const new_plot_btn = {
  add_new_graph: (intl) => (isLTPM ? intl.formatMessage({ id: "graphing.add.new.graph" }) : "Add New Graph"),
}

export default function NewPlotButton({
  placement = "bottom",
  btnText,
  plotList,
  updatePlots,
  siteReactors = [],
  intl,
}) {
  return (
    <ObservationSelectorPopper
      options={plotList}
      placement={placement}
      nameFn={(plot) => plot.title}
      onSelect={(sel) => {
        const new_graph = { ...sel }
        updatePlots((plots) => [...plots, new_graph])
      }}
      runFilters={siteReactors}
    >
      <Button title={new_plot_btn.add_new_graph(intl)} variant={"outline-primary"}>
        <span className="fa fa-plus-circle" />
        {btnText ? <span>&nbsp;{new_plot_btn.add_new_graph(intl)}</span> : <></>}
      </Button>
    </ObservationSelectorPopper>
  )
}
